module.exports = __webpack_public_path__ + "media/images/flags/1x1/moz-90478462d2f13863f9714df4b3f8fa4b.svg";